import React from 'react';

function InlineUpload({ label, id, onUpload, accept = 'image/*', multiple = true }) {
	return (
		<div className="inline-upload">
			<label htmlFor={id} className="gray_dark_02 border-0">
				{label}
			</label>
			<input
				type="file"
				className="file-upload"
				id={id}
				onClick={(e) => (e.target.value = null)}
				onChange={onUpload}
				accept={accept}
				multiple={multiple}
			/>
		</div>
	);
}

export default InlineUpload;
